import { render, staticRenderFns } from "./AdditionalPackages.vue?vue&type=template&id=1ac3d412&scoped=true&"
import script from "./AdditionalPackages.vue?vue&type=script&lang=js&"
export * from "./AdditionalPackages.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPackages.vue?vue&type=style&index=0&id=1ac3d412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac3d412",
  null
  
)

export default component.exports